/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import LazyLoadTransition from '../../../components/LazyLoadTransition/LazyLoadTransition';
import './SpeakersFeatured.css';

const speaker = ({ id, name, company, shortDesc, onSpeakerClick }) => (
    <div
        className="column is-one-quarter-desktop is-one-third-tablet is-full-mobile"
        id="speaker-card"
        key={id}
    >
        <LazyLoadTransition>
            <div
                className={`card${id.includes('unknown') ? '' : ' featured-speaker'}`}
                onClick={onSpeakerClick(id)}
            >
                <div className="card-content">
                    <img
                        alt="speaker"
                        onError={e => {
                            e.target.src = 'imgs/speakers/unknown.png';
                        }}
                        src={`imgs/speakers/${id}.jpg`}
                    />
                    <p className="speaker-featured-name">{name}</p>
                    <p className="speaker-featured-company">{company}</p>
                    <p className="speaker-featured-short-desc">{shortDesc}</p>
                </div>
            </div>
        </LazyLoadTransition>
    </div>
);

speaker.defaultProps = {
    onSpeakerClick: () => {}
};

speaker.propTypes = {
    company: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onSpeakerClick: PropTypes.func,
    shortDesc: PropTypes.string.isRequired
};

export default speaker;
